import Vue from "vue";
import Router from "vue-router";
import Home from "components/Home.vue";
import Login from "components/Login.vue";
import OrderDetails from "components/OrderDetails.vue";
import NonDelivery from "components/NonDelivery.vue";
//import ListILT from "components/ListILT.vue";
import ListILT2 from "components/ListILT2.vue";
import SolveNonDelivery from "components/SolveNonDelivery.vue";
import store from "./store";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return;
    }
    next("/");
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }
    next("/login");
};

export default new Router({
    mode: "history",
    base: "/RJ.Flessen.App/", //for gh-pages deploy
    //base: "/", //for dev
    routes: [
        {
            path: "/login",
            name: "Login",
            component: Login,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: "/",
            alias: "/index.html",
            name: "Home",
            component: Home,
           // beforeEnter: ifAuthenticated
        },
        {
            path: "/orderdetails/:id",
            name: "OrderDetails",
            component: OrderDetails,
            props: true,
            beforeEnter: ifAuthenticated
        },
        {
            path: "/non-delivery/:id",
            name: "NonDelivery",
            component: NonDelivery,
            props: true,
            beforeEnter: ifAuthenticated
        },
        {
            path: "/solve-non-delivery/:id",
            name: "SolveNonDelivery",
            component: SolveNonDelivery,
            props: true,
            beforeEnter: ifAuthenticated
        },
        // {
        //     path: "/ILT",
        //     name: "ListILT",
        //     component: ListILT,
        //     beforeEnter: ifAuthenticated
        // },
        {
            path: "/ILT2",
            name: "ListILT2",
            component: ListILT2,
            beforeEnter: ifAuthenticated
        }
    ]
});
